"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataHooks = void 0;
var dataHooks = {
  CHECKBOX: 'list-item-select-checkbox',
  PREFIX: 'list-item-select-prefix',
  SUFFIX: 'list-item-select-suffix',
  TITLE: 'list-item-select-title',
  SUBTITLE: 'list-item-select-subtitle'
};
exports.dataHooks = dataHooks;